/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { Trans } from "react-i18next";

class Test extends Component {
  render() {
    const { test } = this.props;
    return (
      <>
        <tr>
          <td className="showGrup">{test.name}</td>
          <td className="showGrup">
            <a
              href={test.link}
              rel="noopener noreferrer"
              target="_blank"
              className="btn btn-fga-view"
            >
              <Trans desc="Göster">10143</Trans>{" "}
              <span className="iconmford fo-icon-search" style={{ fontSize: 0 }}></span>
            </a>
          </td>
        </tr>
      </>
    );
  }
}

export default Test;
